import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_THOUGHT_SPOT_SETTINGS = "GET_THOUGHT_SPOT_SETTINGS";

export const service = async (data) => {
  const options: object = {
    url: `/Api/Thoughtspot/settings/`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_THOUGHT_SPOT_SETTINGS, service, mock);
